module.exports = __webpack_public_path__ + "prod/1.42.2/img/power1.40b388c8.png";